module.exports = __webpack_public_path__ + "static/avs_video_editor_page-1e2199cc118dbf66945532db0b964a3f.mp4";